module.exports = __webpack_public_path__ + "img/medcube_2.f6448363.png";